/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
	// All pages
	'common': {
	    init: function () {
		// JavaScript to be fired on all pages

		jQuery("#back-to-top").on('click', function () {

		    jQuery('html,body').animate({
			scrollTop: 0
		    }, 'fast');
		    return false;
		})

		jQuery('.fancybox-product').fancybox({
		    thumbs: {
			autoStart: true,
			axis: 'x'
		    }
		});

		jQuery('.fancybox-photo').fancybox({
		    thumbs: {
			autoStart: true,
			axis: 'x'
		    }
		});
		
		jQuery('select.country').on('change',function(e){
		   var price = jQuery(this).find('option:selected').val(); 
		   jQuery(this).closest('form').find("#amount-paypal").val(price);
		   jQuery(this).closest('form').find(".price-zone").html(price+"€");
		});
	    },
	    finalize: function () {
		// JavaScript to be fired on all pages, after page specific JS is fired
	    }
	},
	// Home page
	'home': {
	    init: function () {
		// JavaScript to be fired on the home page
		jQuery(".go-down").on('click', function () {

		    jQuery('html,body').animate({
			scrollTop: parseInt(jQuery(this).closest('section').parent().find("section.shop").offset().top - 29)
		    }, 'slow');
		    return false;
		});

		var $grid = jQuery('.products').isotope({
		    itemSelector: '.product-item',
		});

		$grid.imagesLoaded().progress( function() {
		  $grid.isotope('layout');
		});
		jQuery('ul.filters').on('click', 'a', function () {
		     $('ul.filters li').removeClass("current");
		    $(this).closest('li').addClass("current");
		    
		    var filterValue = jQuery(this).attr('data-filter');
		    $grid.isotope({filter: filterValue});
		    return false;
		});
		
		jQuery('.modal-product').on('shown.bs.modal', function () {
//		    console.log( jQuery(this).parent().find('.btn-block'));
//jQuery('.btn-block').trigger('blur');
//jQuery('.btn-block').blur();
//       jQuery(this).parent().find('.btn-block').blur();
        jQuery('.btn-block').one('focus', function(e){$(this).blur();});
   }); 


	    },
	    finalize: function () {
		// JavaScript to be fired on the home page, after the init JS
	    }
	},
	// About us page, note the change from about-us to about_us.
	'photos': {
	    init: function () {
		
		var $grid_picture = jQuery('section.photos .pictures').isotope({
		    itemSelector: '.photo-item',
		      gutter: 30
		});
		
		$grid_picture.imagesLoaded().progress( function() {
		  $grid_picture.isotope('layout');
		  $grid_picture.isotope('shuffle');
		});

		
		jQuery('ul.filters').on('click', 'a', function () {
		    $('ul.filters li').removeClass("current");
		    $(this).closest('li').addClass("current");
		    
		    var filterValue = jQuery(this).attr('data-filter');
		    $grid_picture.isotope({filter: filterValue});
		    return false;
		});
	    }
	},
	'pictures' : {
	    init: function () {
		Sage.photos.init();
	    }
	}
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
	fire: function (func, funcname, args) {
	    var fire;
	    var namespace = Sage;
	    funcname = (funcname === undefined) ? 'init' : funcname;
	    fire = func !== '';
	    fire = fire && namespace[func];
	    fire = fire && typeof namespace[func][funcname] === 'function';

	    if (fire) {
		namespace[func][funcname](args);
	    }
	},
	loadEvents: function () {
	    // Fire common init JS
	    UTIL.fire('common');

	    // Fire page-specific init JS, and then finalize JS
	    $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
		UTIL.fire(classnm);
		UTIL.fire(classnm, 'finalize');
	    });

	    // Fire common finalize JS
	    UTIL.fire('common', 'finalize');
	}
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
